import { render } from "./DatasetManagementDetailView.vue?vue&type=template&id=6371c6fb&scoped=true&ts=true"
import script from "./DatasetManagementDetailView.vue?vue&type=script&lang=ts"
export * from "./DatasetManagementDetailView.vue?vue&type=script&lang=ts"

import "./DatasetManagementDetailView.vue?vue&type=style&index=0&id=6371c6fb&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6371c6fb"]])

export default __exports__